import React, { Fragment } from 'react';
import ConfigurableListFieldsSelect from './ConfigurableListFieldsSelect';
const WidgetOptions = (props) => {
    return (
        <Fragment>
            {props?.element?.key === 'ConfigurableList' && (
                <Fragment>
                    <ConfigurableListFieldsSelect {...props} />
                </Fragment>
            )}
        </Fragment>
    );
};

export default WidgetOptions;
